import httpClient from '../lib/http-client'

const adminApi = {
  findUsers (query) {
    return httpClient.get('/admin/users', {
      params: query
    })
  },
  updateUserStatus (ids, statusCode, actionData) {
    const data = {
      userIds: ids,
      statusCode
    }

    if (actionData && actionData.reason) {
      data.reason = actionData.reason
    }

    return httpClient.put('/admin/users/status', data)
  },
  removeUsers (ids) {
    const data = {
      userIds: ids
    }

    return httpClient.delete('/admin/users', { data })
  },
  findReports (query) {
    return httpClient.get('/admin/reports', {
      params: query
    })
  }
}

export default adminApi



// WEBPACK FOOTER //
// ./src/api/admin.js